const LocalVars = {
  debugMode     : true,
  serverURL     : 'https://api.backendless.com',
  XMLHttpRequest: typeof XMLHttpRequest !== 'undefined' ? XMLHttpRequest : undefined,
  applicationId : null,
  secretKey     : null,
  appPath       : null,
  ServerCode    : null
}

export default LocalVars


// WEBPACK FOOTER //
// ./src/local-vars.js